export const panelList = [
  {
    name: "forms",
    tooltip: "personal-forms-tooltip",
    image: "personal/poll",
  },
  {
    name: "design",
    tooltip: "personal-design-tooltip",
    image: "personal/paint",
  },
  {
    name: "social",
    tooltip: "personal-social-tooltip",
    image: "personal/link",
  },
  {
    name: "seo",
    tooltip: "personal-seo-tooltip",
    image: "personal/seo-search",
  },
];

export const listViews = ["desktop", "tablet", "mobile"];

